import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'hr',
    name: 'HR',
    description: 'Employees, absence, onboarding and the employee record.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'hr',
    features: [
        { key: 'hr.payroll_export', description: 'Structured export to a payroll provider' },
        { key: 'hr.recruitment', description: 'Applicant tracking and onboarding' },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds payroll export and recruitment',
            features: ['hr.payroll_export', 'hr.recruitment'],
            limits: ['user', 'active_user', 'legal_entity'],
        },
    ],
    limitTypes: ['user', 'active_user', 'legal_entity'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'attachments',
        'party_master',
        'workforce_ops',
        'compliance_kernel',
    ],
    optionalModules: ['projects'],
    integrationDeps: ['payroll-provider'],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map